import { render, staticRenderFns } from "./ConfigsDetailRow.vue?vue&type=template&id=57884472&"
import script from "./ConfigsDetailRow.vue?vue&type=script&lang=js&"
export * from "./ConfigsDetailRow.vue?vue&type=script&lang=js&"
import style0 from "./ConfigsDetailRow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports